import { render, staticRenderFns } from "./BannerMessage.vue?vue&type=template&id=6e58e8aa&scoped=true"
import script from "./BannerMessage.vue?vue&type=script&lang=ts"
export * from "./BannerMessage.vue?vue&type=script&lang=ts"
import style0 from "./BannerMessage.vue?vue&type=style&index=0&id=6e58e8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e58e8aa",
  null
  
)

export default component.exports